module.exports = __webpack_public_path__ + "img/position.dc6054cc.gif";